import { useState } from 'react';
import { Pause, Play, User } from 'lucide-react';
import { Artist } from '../artistList/artist';
import { artistPhotoUrl } from '../../../config/images';
import './Cards.css';

interface Props {
    artist: Artist;
    onClick: (artist: Artist) => void;
    onPlay?: (artist: Artist) => void;
    isPlaying?: boolean;
}

export function ArtistCard({ artist, onClick, onPlay, isPlaying }: Props): React.JSX.Element {
    const [imageFailed, setImageFailed] = useState(false);
    const photo = artistPhotoUrl(artist.getId());

    return (
        <div className="gridCard" onClick={() => onClick(artist)}>
            <div className="gridCardArt gridCardArtCircle">
                {photo && !imageFailed ? (
                    <img
                        src={photo}
                        alt={artist.getTitle()}
                        onError={() => setImageFailed(true)}
                    />
                ) : (
                    <User size={28} strokeWidth={2.75} />
                )}
                {onPlay && (
                    <button
                        className={`gridCardPlayButton ${isPlaying ? 'gridCardPlayButtonVisible' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlay(artist);
                        }}
                        aria-label={isPlaying ? `Pause ${artist.getTitle()}` : `Play ${artist.getTitle()}`}
                    >
                        {isPlaying ? (
                            <Pause size={16} strokeWidth={2.75} fill="currentColor" />
                        ) : (
                            <Play size={16} strokeWidth={2.75} fill="currentColor" />
                        )}
                    </button>
                )}
            </div>
            <div className="gridCardMeta">
                <span className="gridCardTitle">{artist.getTitle()}</span>
            </div>
        </div>
    );
}
